import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import styled from 'styled-components'
import LinkButton from "../atoms/link-button"
import { DEPARTMENTS, DUMMY_RANK_STATS } from "../../constants/constants"
import { formatDepartment } from "../../utils/str"

const styles = theme => ({
  root: {
    padding: "45px 30px",
    boxSizing: "border-box",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: "45px 20px",
    },
  },

  text1: {
    textAlign: "center",
    fontSize: "18px",
    lineHeight: "18px",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "16px",
    },
  },

  text2: {
    marginTop: "16px",
    textAlign: "center",
    lineHeight: "28px",
    fontSize: "28px",
    fontWeight: "bold",
    [theme.breakpoints.down("xs")]: {
      fontSize: "23px",
    },
  },

  rankCircle: {
    width: "100px",
    height: "100px",
    lineHeight: "100px",
    border: "2px solid #0955EF",
    borderRadius: "50%",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      width: "72px",
      height: "72px",
      lineHeight: "72px",
    },
  },

  rankTitleContainer: {
    display: "flex",
    justifyContent: "center",
  },

  rankTitle: {
    textAlign: "center",
    marginTop: "50px",
    fontSize: "13px",
    fontWeight: "bold",
    background: "#EFF7FF",
    color: "#1866FF",
    padding: "12px 0",
    width: "520px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "30px",
    }
  },

  rankCategoryContainer: {
    marginTop: "20px",
    display: "flex",
    justifyContent: "center",
  },

  rankCategory: {
    color: "#1866FF",
    fontSize: "13px",
    fontWeight: "bold",
    cursor: "pointer",
  },

  button: {
    color: "#71737B",
    fontSize: "11px",
    minWidth: "unset",
    minHeight: "unset",
    padding: "5px 10px",
    marginRight: "-10px",
    textDecoration: "none",
    "&:hover": {
      background: "none",
      textDecoration: "underline",
    },
  },

  industryContainer: {
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "12px",
  },

  industryItem: {
    marginRight: "5px",
    fontSize: "12px",
  },

  rankItemsContainer: {
    display: "flex",
    justifyContent: "center",
  },

  rankItems: {
    display: "flex",
    width: "520px",
    justifyContent: "space-around",
  },

  rankItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  rankRatioType: {
    fontSize: "12px",
    fontWeight: "bold",
    marginTop: "15px",
  },

  rankRatioText: {
    [theme.breakpoints.down("xs")]: {
      display: "block",
      textAlign: "center",
      lineHeight: "1.25"
    }
  },

  rankText: {
    marginLeft: "3px",
  },

  rankNo: {
    fontSize: "28px",
    fontWeight: "bold",
  },

  rankUnit: {
    fontSize: "18px",
  },

  rankDesc: {
    paddingTop: "25px",
    fontSize: "13px",
    textAlign: "center",
    lineHeight: "1",
    color: "#000000",
  },

  prompt: {
    marginTop: "50px",
    fontWeight: "bold",
    fontSize: "13px",
    textAlign: "center",
    [theme.breakpoints.down("xs")]: {
      marginTop: "40px",
    }
  },

  buttonContainer: {
    marginTop: "28px",
    display: "flex",
    justifyContent: "center",
  },

  buttonsArea : {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },

  buttonMargin : {
    marginTop: "0px",
    marginLeft: "20px",
    [theme.breakpoints.down("xs")]: {
      marginTop: "10px",
      marginLeft: "0px",
    },
  },
})

const FadeIn = (
  <style>
    {`
      @keyframes FadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
      }
    `}
  </style>
);

class RankingProfile extends React.Component {
  state = {
    jsic_l: "",
    jsic_s: "",
    department: "",
    departmentKey: "",
    showDepartment: true,
  }

  showDepartment = () => {
    this.setState({
      showDepartment: true,
    })
  }

  showIndustry = () => {
    this.setState({
      showDepartment: false,
    })
  }

  componentDidMount() {
    const { item } = this.props

    if (item && !!item.corporation_detail_detail) {
      const detail = JSON.parse(item.corporation_detail_detail)

      let jsic_l = "",
        jsic_s = ""

      if (detail.hasOwnProperty("jsic_l")) {
        jsic_l = detail["jsic_l"]
      }

      if (detail.hasOwnProperty("jsic_s")) {
        jsic_s = detail["jsic_s"]
        this.props.getRankJsicSById(jsic_s)
      }

      let department = ""
      let departmentKey = ""

      if (item.hasOwnProperty("honorific")) {
        department = formatDepartment(item.honorific)
      }

      if (department !== "") {
        departmentKey = DEPARTMENTS.find(item => item.name === department).value
        this.props.getRankDepartmentsById(departmentKey)
      }

      this.setState({
        jsic_l: jsic_l,
        jsic_s: jsic_s,
        department: department,
        departmentKey: departmentKey,
        showDepartment: department !== "",
      })
    }
  }

  render() {
    const { classes, jsicSRankStats, departmentRankStats = null , text1, text2 } = this.props
    const { jsic_s, department, departmentKey } = this.state

    let industryStats =
      jsic_s !== "" && jsicSRankStats.hasOwnProperty(jsic_s)
        ? jsicSRankStats[jsic_s]
        : DUMMY_RANK_STATS

    let departmentStats =
      departmentRankStats !== null && departmentRankStats.hasOwnProperty(departmentKey)
        ? departmentRankStats[departmentKey]
        : DUMMY_RANK_STATS

    return (
      <div className={classes.root}>
        <div>
          <div className={classes.text1}>{`${text1}`}</div>
          <div className={classes.text2}>{`${text2}`}</div>
        </div>
        {(jsic_s !== "" || department !== "") && (
          <div className={classes.rankTitleContainer}>
            <div className={classes.rankTitle}>
              レター送付・商談率 ランキング
            </div>
          </div>
        )}
        <div className={classes.rankCategoryContainer}>
          {department !== "" && (
            <UnderLine className={classes.rankCategory} style={{ opacity: this.state.showDepartment ? "1" : "0.5"}} onClick={this.showDepartment}>
              部門別ランキング
            </UnderLine>
          )}
          {jsic_s !== "" && (
            <UnderLine className={classes.rankCategory} style={{ marginLeft: department === "" ? "0px" : "45px", opacity: this.state.showDepartment ? "0.5" : "1" }} onClick={this.showIndustry}>
                業界別ランキング
            </UnderLine>
          )}
        </div>
        <div style={{ marginTop: "40px"}}>
          {FadeIn}
          {department !== "" && (
            <div style={{ display: this.state.showDepartment ? '' : 'none' , animation: this.state.showDepartment ? 'FadeIn 1s' : '' }}>
              <div className={classes.rankItemsContainer}>
                <div className={classes.rankItems}>
                  <div className={classes.rankItem}>
                    <div className={classes.rankCircle}>
                      <span className={classes.rankText}>
                        <span className={classes.rankNo}>{departmentStats["letter_rank"]}</span>
                        <span className={classes.rankUnit}>位</span>
                      </span>
                    </div>
                    <span className={classes.rankRatioType}>
                      <span className={classes.rankRatioText}>レター送付率</span>
                      <span className={classes.rankRatioText}>ランキング</span>
                    </span>
                  </div>
                  <div className={classes.rankItem}>
                    <div className={classes.rankCircle}>
                      <span className={classes.rankText}>
                        <span className={classes.rankNo}>{departmentStats["reaction_rank"]}</span>
                        <span className={classes.rankUnit}>位</span>
                      </span>
                    </div>
                    <span className={classes.rankRatioType}>
                      <span className={classes.rankRatioText}>レター確認率</span>
                      <span className={classes.rankRatioText}>ランキング</span>
                    </span>
                  </div>
                  <div className={classes.rankItem}>
                    <div className={classes.rankCircle}>
                      <span className={classes.rankText}>
                        <span className={classes.rankNo}>{departmentStats["shoudan_rank"]}</span>
                        <span className={classes.rankUnit}>位</span>
                      </span>
                    </div>
                    <span className={classes.rankRatioType}>
                      <span className={classes.rankRatioText}>レター商談率</span>
                      <span className={classes.rankRatioText}>ランキング</span>
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.rankDesc}>※全{departmentStats["denominator"]}部門のランキングを表示しています。</div>
            </div>
          )}

          {jsic_s !== "" && (
            <div style={{ display: this.state.showDepartment ? 'none' : '', animation: this.state.showDepartment ? '' : 'FadeIn 1s' }}>
              <div className={classes.rankItemsContainer}>
                <div className={classes.rankItems}>
                  <div className={classes.rankItem}>
                    <div className={classes.rankCircle}>
                      <span className={classes.rankText}>
                        <span className={classes.rankNo}>{industryStats["letter_rank"]}</span>
                        <span className={classes.rankUnit}>位</span>
                      </span>
                    </div>
                    <span className={classes.rankRatioType}>
                      レター送付率ランキング
                    </span>
                  </div>
                  <div className={classes.rankItem}>
                    <div className={classes.rankCircle}>
                      <span className={classes.rankText}>
                        <span className={classes.rankNo}>{industryStats["reaction_rank"]}</span>
                        <span className={classes.rankUnit}>位</span>
                      </span>
                    </div>
                    <span className={classes.rankRatioType}>
                      レター確認率ランキング
                    </span>
                  </div>
                  <div className={classes.rankItem}>
                    <div className={classes.rankCircle}>
                      <span className={classes.rankText}>
                        <span className={classes.rankNo}>{industryStats["shoudan_rank"]}</span>
                        <span className={classes.rankUnit}>位</span>
                      </span>
                    </div>
                    <span className={classes.rankRatioType}>
                      レター商談率ランキング
                    </span>
                  </div>
                </div>
              </div>
              <div className={classes.rankDesc}>※全{industryStats["denominator"]}業界のランキングを表示しています。</div>
            </div>
          )}
        </div>
        <div className={classes.prompt}>
          <div>Keyman Letterを使って決裁者との商談を獲得しましょう。</div>
          <div>数多くの決裁者情報からターゲットを探し、手紙を送付することができます。</div>
        </div>
        <div className={classes.buttonContainer}>
          <div className={classes.buttonsArea}>
            <div>
              <LinkButton
                color={"#FFFFFF"}
                bgColor={"#B9B9B9"}
                bgColorHover={"#A0A0A0"}
                href={"https://keymanletter.com/"}
                text={"詳細はこちら"}>
              </LinkButton>
            </div>
            <div className={classes.buttonMargin}>
              <LinkButton 
                color={"#FFFFFF"}
                bgColor={"#FFBB02"}
                bgColorHover={"#EDAD00"}
                href={"https://keymanletter.com/#inquiry"}
                text={"まずはお問い合わせ"}>
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const UnderLine = styled.div`
position: relative;
::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -10px; /*下線の上下位置調整*/
  display: inline-block;
  width: 30px;
  height: 2px;
  -moz-transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translate(-50%);
  background-color: #1866FF;
`

RankingProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  jsicSRankStats: PropTypes.object,
  getRankJsicSById: PropTypes.func.isRequired,
}

RankingProfile.defaultProps = {
  text1: "Keyman Letterを使えば...",
  text2: "この方に手紙を送ることができます",
}

export default withStyles(styles)(RankingProfile)
